import cssUtil from 'gw-portals-util-js/CssUtil';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import MockUpUtil from 'edge/api/gw-portals-util-js/MockUpUtil';
import LocalDateUtil from 'edge/api/gw-portals-util-js/LocalDateUtil';


const mockUpUtil = new MockUpUtil();

const fn = ($filter, $scope, $state, $stateParams, $translate,
    ViewModelService, InsuranceSuiteMetadata, UserInfoService, ModalService, PolicyService, ActivityService) => {

    const ctrl = Object.create(BaseCtrl);
    $scope.errorMsg = null;
    $scope.error = false;

    $scope.policyNumber = $scope.$parent.policyNumber;
    if ($scope.$parent.accountInfo != undefined) {
        $scope.accountNumber = $scope.$parent.accountInfo.accountNumber;
    }
    if ($scope.accountNumber == undefined) {
        window.location.hash = "#/home";
    }

    ctrl.init = () => {
        console.log("Complaints activity inside init method call");
        $scope.subjectList = ['Claims', 'Contract', 'Other', 'Product'];
        $scope.activityAmount = [];
        $scope.showForm = false;

        $scope.activityInfoView = ViewModelService.create({}, 'pc', 'edge.capabilities.gateway.activity.dto.ActivityDTO');
        $scope.noteInfo = ViewModelService.create({}, 'pc', 'edge.capabilities.gateway.note.dto.NoteDTO');
        $scope.noteInfo.text = " ";
        $scope.noteInfo.topic = "complaints";
        $scope.noteInfo.topic_PSA = "complaints";
        $scope.noteInfo.authorName = $filter('translate')('gateway.directives.activity-summary.Complaints');

        $scope.activityPatternInfo = {
            "code": "",
            "priority": "",
            "subject": "",
            "category": {
                "code": "Complaints_acknowledge",
                "priority": 1
            }
        }

        $scope.activityData = {
            "priority": "",
            "dueDate": "",
            "escalationDate": "",
            "subject": "",
            "description": "",
            "complaintID_PSA": 1,
            "nameOfComplainant": "",
            "receivedDate": "",
            "activityPattern": $scope.activityPatternInfo
        }

        if ($scope.policyNumber != null) {
            $scope.relatedToList = [$filter('translate')('gateway.views.account-detail.Account') + " : " + $scope.accountNumber, '--' + $filter('translate')('gateway.directives.activity-summary.Policy') + ' : ' + $scope.policyNumber];

            const policyPromise = ActivityService.getActivitiesForPolicy($scope.policyNumber);

            policyPromise.then((activitiesFromServer) => {
                $scope.activities = activitiesFromServer;
                $scope.activityAmount = activitiesFromServer;
            }).catch((error) => {
                ModalService.showError('gateway.directives.ActivitySummary.Error');
            });
        } else {
            $scope.relatedToList = [$filter('translate')('gateway.views.account-detail.Account') + " : " + $scope.accountNumber];

            const accountPromise = ActivityService.getActivitiesForAccount($scope.accountNumber);

            accountPromise.then((activitiesFromServer) => {
                $scope.activities = activitiesFromServer;
                $scope.activityAmount = activitiesFromServer;
            }).catch((error) => {
                ModalService.showError('gateway.directives.ActivitySummary.Error');
            });
        }
        $scope.activityInfoView.receivedDate = LocalDateUtil.today();
        $scope.activityInfoView.dueOneDate = LocalDateUtil.today(5);
        $scope.activityInfoView.escalationOneDate = LocalDateUtil.today(4);
        $scope.activityInfoView.assignedTo = PSAUSER.displayName;
        $scope.activityInfoView.topic = "Complaints";

        //Get complaint id from policy center
        const operation = ActivityService.getComplaintID();
        operation.then((result) => {
            $scope.activityInfoView.complaintID_PSA = result.complaintID;
        }).catch((error) => {
            ModalService.showError('gateway.views.modal.Error', 'Error while fetching the complaint ID');
        });

        //Get activity patterns for policy
        const actPromise = ActivityService.getActivityPatternsFor('policy');
        actPromise.then((activityPatterns) => {
            $scope.activityPatterns = activityPatterns;
        }).catch((error) => {
            ModalService.showError('gateway.directives.add-activity.ActivityPattern retrieval failed');
        });

    };

    ctrl.cancel = function () {
        $scope.showForm = false;
        //        if ($scope.policyNumber != null) {
        //            window.location.hash = "#/policies/" + $scope.policyNumber + "/summary";
        //        } else {
        //            window.location.hash = "#/accounts/" + $scope.accountNumber + "/summary";
        //        }
    };

    ctrl.showAddActivity = () => {
        $scope.showForm = true;
    };

    ctrl.getTodayDate = (increment = 0) => {
        const date = new Date();
        if (increment) {
            date.setDate(date.getDate() + increment);
        }
        date.setHours(0, 0, 0, 0);
        return date;
    };

    ctrl.save = function (activityForm) {
        activityForm.submitted = true;
        if (activityForm.invalid) {
            return;
        }
        $scope.noteInfo.subject = $scope.activityInfoView.subject.value;
        $scope.noteInfo.body = $scope.noteInfo.text.value;

        $scope.activityPatternInfo.code = $scope.activityPatterns.filter(item => item.subject == $scope.noteInfo.subject.value)[0].code;
        $scope.activityPatternInfo.priority = $scope.activityInfoView.priority.value.code;
        $scope.activityPatternInfo.subject = $scope.activityInfoView.subject.value;

        if ($scope.policyNumber != null) {
            $scope.activityData.policyNumber = $scope.policyNumber;
            $scope.noteInfo.relatedTo = "Policy";
        } else {
            $scope.activityData.accountNumber = $scope.accountNumber;
            $scope.noteInfo.relatedTo = "Account";
        }
        $scope.activityData.dueDate = moment(ctrl.getTodayDate(5)).format("YYYY-MM-DDTHH:mm:ss") + "Z";
        $scope.activityData.escalationDate = moment(ctrl.getTodayDate(4)).format("YYYY-MM-DDTHH:mm:ss") + "Z";
        $scope.activityData.receivedDate = moment(ctrl.getTodayDate()).format("YYYY-MM-DDTHH:mm:ss") + "Z";
        $scope.activityData.priority = $scope.activityInfoView.priority.value.code;
        $scope.activityData.subject = $scope.activityInfoView.subject.value;
        $scope.activityData.description = $scope.activityInfoView.description.value;
        $scope.activityData.complaintID_PSA = $scope.activityInfoView.complaintID_PSA.value;
        $scope.activityData.activityPattern = $scope.activityPatternInfo;
        $scope.activityData.nameOfComplainant = $scope.activityInfoView.nameOfComplainant.value;
        $scope.activityData.claimNumber = $scope.activityInfoView.claimNumber.value;

        console.log($scope.noteInfo.value);
        console.log($scope.activityData);

        const operation = ActivityService.createNewActivity($scope.activityData, $scope.noteInfo.value);
        operation.then((result) => {
            ModalService.showInfo('gateway.directives.add-activity.Activity created');
            ctrl.init();
        }).catch((error) => {
            ModalService.showError('gateway.directives.add-activity.Failed to create Activity');
        });
    };

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$stateParams', '$translate', 'ViewModelService', 'InsuranceSuiteMetadata', 'UserInfoService', 'ModalService', 'PolicyService', 'ActivityService'];
export default fn;